module.exports = __webpack_public_path__ + "img/fsa-icon.33387d3c.svg";